import React, {Component} from 'react'

class TelaBemVindo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            servidor: props.servidor,
        }
    }

    render() {
        //let empresa = this.state.servidor
        //let empresa_upper = empresa.charAt(0).toUpperCase() + empresa.slice(1)

        return(
            <div>
                <br />
                <p>O sigilo da sua identidade e informações será resguardado na forma da lei. Ao registrar a denúncia, você pode escolher a forma de acordo com as opções:</p>
                <p><span className="negrito">Identificada:</span> Você se identifica e registra os seus dados.</p>                
                <p><span className="negrito">Anônima:</span> Você não se identifica, apenas registra a denúncia.</p>
                <p>Lembre-se de fornecer o máximo de detalhes para que a apuração ocorra de forma rápida.</p>
                <br /><br />
                
                <p align="center">
                    <a href="/incidente?t=1" title="Realizar denúncia com identificação" shape="rect" className="mr20 bt_realizar_denuncia_identificada"></a>
                    <a href="/incidente" title="Realizar denúncia anônima" shape="rect" className="bt_realizar_denuncia_anonima"></a>
                </p>
            </div>
        )
    }
}

export default TelaBemVindo